import { Badge, Box, Button, Grid, Input } from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { IconSearch } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import {
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import { _localization } from "../../../config/location";

import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { DuplicateReport } from "../../../model/DuplicateReport";

type Props = {
  duplicateCheckKey: number;
};
const DuplicateCheck = ({ duplicateCheckKey }: Props) => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<DuplicateReport[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 1.7 };

  const formSeachInput = useForm<{
    keySearch: string;
  }>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: "",
    },
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (formSeachInput.getValues().keySearch) {
      url += `&KeySearch=${formSeachInput.getValues().keySearch}`;
    }
    // Xác định URL API dựa trên giá trị của duplicateCheckKey
    let apiEndpoint = "";
    switch (duplicateCheckKey) {
      case 1:
        apiEndpoint = `/api/v1/DuplicateReport/check-1`; //Check trùng mã phiếu thu chi, báo có
        break;
      case 2:
        apiEndpoint = `/api/v1/DuplicateReport/check-2`; //Check trùng phiếu nhập, xuất cho đơn hàng,đơn DT
        break;
      case 3:
        apiEndpoint = `/api/v1/DuplicateReport/check-3`; //Check xóa nhân viên
        break;
      case 4:
        apiEndpoint = `/api/v1/DuplicateReport/check-4`; //Check đơn hàng không thấy người bán, người tạo, người hưởng
        break;
      default:
        apiEndpoint = "";
        break;
    }
    try {
      const response = await repositoryPos.get(`${apiEndpoint}${url}`);
      if (response && response.success) {
        console.log("response", response);
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<DuplicateReport>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      ...(duplicateCheckKey === 1
        ? [
            {
              accessorKey: "receiptNumber",
              header: "Mã phiếu",
              Cell: ({ renderedCellValue }: any) => (
                <>
                  <Badge variant="dot" color="lime" size="md" radius="sm">
                    {renderedCellValue}
                  </Badge>
                </>
              ),
            },
          ]
        : []),
      ...(duplicateCheckKey === 2
        ? [
            {
              accessorKey: "sourceCode",
              header: "Mã phiếu",
              Cell: ({ renderedCellValue }: any) => (
                <>
                  <Badge variant="dot" color="lime" size="md" radius="sm">
                    {renderedCellValue}
                  </Badge>
                </>
              ),
            },
          ]
        : []),
      ...(duplicateCheckKey === 2
        ? [
            {
              accessorKey: "sourceType",
              header: "Loại giao dịch",
            },
          ]
        : []),

      ...(duplicateCheckKey === 2
        ? [
            {
              accessorKey: "transactionDate",
              header: "Ngày giao dịch",
              Cell: ({ renderedCellValue }: any) => (
                <>{formatDateTransfer(renderedCellValue)}</>
              ),
            },
          ]
        : []),
      ...(duplicateCheckKey === 3 || duplicateCheckKey === 4
        ? [
            {
              accessorKey: "orderNumber",
              header: "Mã đơn hàng",
              Cell: ({ renderedCellValue }: any) => (
                <>
                  <Badge variant="dot" color="lime" size="md" radius="sm">
                    {renderedCellValue}
                  </Badge>
                </>
              ),
            },
          ]
        : []),
      ...(duplicateCheckKey === 3 || duplicateCheckKey === 4
        ? [
            {
              accessorKey: "createBy",
              header: "Id người tạo",
            },
          ]
        : []),
      ...(duplicateCheckKey === 3
        ? [
            {
              accessorKey: "nguoiTao",
              header: "Người tạo",
            },
          ]
        : []),
      ...(duplicateCheckKey === 3 || duplicateCheckKey === 4
        ? [
            {
              accessorKey: "saleId",
              header: "Id người bán",
            },
          ]
        : []),
      ...(duplicateCheckKey === 3
        ? [
            {
              accessorKey: "nguoiBan",
              header: "Người bán",
            },
          ]
        : []),
      ...(duplicateCheckKey === 3 || duplicateCheckKey === 4
        ? [
            {
              accessorKey: "attribute18",
              header: "Id người hưởng số",
            },
          ]
        : []),
      ...(duplicateCheckKey === 3
        ? [
            {
              accessorKey: "nguoiHuong",
              header: "Người hưởng số",
            },
          ]
        : []),
      ...(duplicateCheckKey === 1 || duplicateCheckKey === 2
        ? [
            {
              accessorKey: "quantity",
              header: "Số lần trùng",
            },
          ]
        : []),
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "maCt"],
      },
      density: "xs",
    },
    enableStickyFooter: true,
    enableRowSelection: false,
    enableToolbarInternalActions: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (240 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
        ref={headerRef}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Grid style={{ width: "100%" }} mt={10}>
            <Grid.Col span={sizeGrid}>
              <Input
                size="sm"
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("keySearch")}
                {...formSeachInput.getInputProps("keySearch")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Button
                type="submit"
                leftSection={<IconSearch size={20} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Box>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default DuplicateCheck;
